import { z } from 'zod';
import { ApplicationStatus } from '../../graphql/operations';

export const applicationStatusSchema = z.nativeEnum(ApplicationStatus);
